var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGlassesV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m3.16 3.75-.15.41L.82 10H0v1.25h.63v1.25a3.76 3.76 0 0 0 3.75 3.75h1.25a3.76 3.76 0 0 0 3.75-3.75v-1.87c0-.36.27-.63.62-.63s.63.27.63.63v1.87a3.76 3.76 0 0 0 3.74 3.75h1.26a3.76 3.76 0 0 0 3.74-3.75v-1.25H20V10h-.82l-2.19-5.84-.15-.41h-1.21l-.18.23-1.56 1.88.97.78 1.2-1.44 1.8 4.8h-6.1A1.9 1.9 0 0 0 10 8.75c-.8 0-1.5.53-1.76 1.25h-6.1l1.8-4.8 1.2 1.44.97-.78-1.56-1.88-.17-.23zm-1.28 7.5h6.25v1.25a2.5 2.5 0 0 1-2.5 2.5H4.38a2.5 2.5 0 0 1-2.5-2.5zm10 0h6.24v1.25a2.5 2.5 0 0 1-2.5 2.5h-1.24a2.5 2.5 0 0 1-2.5-2.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlassesV2);
export default ForwardRef;